var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-flex-direction-row is-align-items-center",staticStyle:{"user-select":"none","height":"100%","width":"100%"}},[_c('div',{staticClass:"mx-3 is-flex is-align-items-center"},[_c('user-image',{staticClass:"userImageContainer"})],1),_c('b',{staticClass:"mr-3 user-name"},[_vm._v(_vm._s(_vm.userFirstName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }